<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="mt-4 mb-4">
          <h1><strong class="courier">scoreboard()</strong></h1>
          <em class="monaco">fast and more.</em>
        </div>
        <div class="card text-white text-left mb-5">
          <div class="maskot">
            <img src="~@/assets/img/maskot.png" class="maskot-img" />
          </div>
          <div class="card-body">
            <!-- <button @click="urutkan" class="btn btn-danger text-white mt-5 mb-3">Urutkan</button> -->
            <div class="table-responsive pt-5">
              <div class="alert alert-info">
                <h3>Keterangan</h3>
                ⚠️ jawaban sedang diuji <br>
                ✅ jawaban benar <br>
                ❌ jawaban salah
              </div>
              <div class="pb-3">
                <input v-model="keyword" type="search" class="form-control form-control-lg" placeholder="search by name or class">
              </div>
              <p class="monaco">
                there are {{ filterContestant.length }} submissions.
              </p>
              <table class="table table-striped text-white">
                <thead>
                  <tr>
                    <th>NAME</th>
                    <th>CLASS</th>
                    <th>CASE</th>
                    <th>TIME</th>
                    <th class="text-center">STATUS</th>
                    <!-- <th>ACTION</th> -->
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contestants: [],
      keyword: '',
    };
  },
  async mounted() {
    // await this.getData();
  },

  created() {
    // this.subsData()
  },

  methods: {
    async getData() {
      const { data, error } = await this.$supabase
        .from('score2023')
        .select()
        .order('id, status, nama', { ascending: true})

      if(error) throw error

      this.setData(data)
    },

    setData(data) {
      this.contestants = data;
      // for (let i = 0; i < data.length; i++) {
      //   let timescore = data[i].created_at
      //   let dt = timescore.toUTCString()
      //   console.log(dt)
      //   this.contestants[i].created_at = dt.getDate() + "/" + dt.getMonth() + "/" + dt.getFullYear()+1+", "+dt.getHours()+":"+dt.getMinutes()+":"+dt.getSeconds()
      // }
      // console.log(this.contestants)
    },

    subsData() {
      const mySubscription = this.$supabase
        .from('score')
        .on('INSERT', (data) => {
          if(data.new) {
            this.contestants.push(data.new)
          }
        })
        .subscribe()
    },
  },

  computed: {
    filterContestant() {
      return this.contestants.filter((c) => {
        return (
          c.nama.toUpperCase().includes(this.keyword.toUpperCase()) ||
          c.kelas.toUpperCase().includes(this.keyword.toUpperCase()) ||
          c.status.toUpperCase().includes(this.keyword.toUpperCase())
        )
      })
    }
  }
};
</script>

<style scoped>
.form-control {
  border: none;
  border-radius: 25px;
}
.form-group {
  margin-bottom: 1.2em;
}
</style>
